import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {getDownloadFileLink} from 'api/debtCollectionMonitor';
import styles from './File.module.sass';
import Question from 'components/common/Question';
import DeleteIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';
import {toDate} from 'data/converter';
import CircularProgress from '@material-ui/core/CircularProgress'
import Label from 'components/common/Label';
import ButtonIcon from 'components/common/ButtonIcon';

@connect()
class AttachFileList extends PureComponent {
  handlerOnDelete =  async (file) => {
    const {onChange} = this.props;
    const {files} = this.props;
    let nextFiles = files.filter(a => file !== a);

    if (onChange) onChange(nextFiles);
  };

  render() {
    const {files, className: classBox, onChange, fetchingFiles: queue} = this.props;
    return (
      <div className={cx(classBox, styles.filesBox)}>
        {files && files.map(file =>
          <div key={file.id} className={styles.fileRow}>
            <div className={styles.fileBox}>
              <div className={styles.fileInfoBox}>
                <a href={getDownloadFileLink(file.id)} download>{file.name}</a>
              </div>
              <div className={styles.iconsBox}>
                {onChange && <Question header="Вы уверены что хотите удалить файл?" ok="Удалить" onOk={() => this.handlerOnDelete(file)}>
                  <ButtonIcon tooltip={"Удалить"} tooltipPosition={"right"} className={styles.iconFileBox}><DeleteIcon className={styles.iconFileIcon}/></ButtonIcon>
                </Question>
                }
              </div>
            </div>

            <div className={styles.fileSubInfoBox}>
              {(file.authorFullName || file.time) &&
              <div className={styles.fileSubInfo}>
                {file.authorFullName && <div className={styles.fileInfoAuthor}>{file.authorFullName}</div>}
                {file.time && <div className={styles.fileInfoTime}>{toDate(file.time)}</div>}
              </div>
              }
              {file.description && <Label className={styles.fileDescription}>{file.description}</Label>}
            </div>

          </div>
        )}
        {queue && queue.length > 0 && queue.map(file =>
          <div key={file.key} className={styles.fileRow}>
            <div className={styles.fileBox}>
              <div className={styles.fileInfoBox}><div><div className={styles.queueFileName}>{file.name}</div></div></div>
              {!file.error
              &&
              <Tooltip title="Загружается" placement="right" >
                <CircularProgress style={{margin: '0 0 0 20px'}} size={25} thickness={7} />
              </Tooltip>
              ||
              <div>{file.error}</div>
              }
            </div>
          </div>
        )}
      </div>
    );
  }
}

AttachFileList.propTypes = {
  className: PropTypes.string,

  files: PropTypes.arrayOf(PropTypes.objectOf({
    id: PropTypes.string,
    name: PropTypes.string,
  })),

  fetchingFiles: PropTypes.arrayOf({
    key: PropTypes.string,
    name: PropTypes.string,
    error: PropTypes.string,
  }),

  onChange: PropTypes.func,
};

export default AttachFileList;


// WEBPACK FOOTER //
// ./src/components/common/AttachFile/AttachFileList.jsx